import auth0Client from './auth0Client'
import AuthInitialiser from './AuthInitializer'
import checkSession from './AuthInitializer/checkSession'
import loadAuth0User from './AuthInitializer/loadAuth0User'
import loadUserData from './AuthInitializer/loadUserData'

export const authInitialiser = new AuthInitialiser({ auth0Client, checkSession, loadAuth0User, loadUserData })

export default {
  auth0Client,
  authInitialiser,
}
